export default __webpack_public_path__ + "static/la_vanguardia_logo-2590b12691bcd9a4c110188a1256e390.jpg";